import React from 'react';
import { Navigate } from 'react-router-dom';

function PublicRoute({ children, isLoggedIn }) {
    return isLoggedIn ? <Navigate to="/dashboard" /> : children;
}

export default PublicRoute;
